import React from "react";
import {NavLink} from "react-router-dom";

const ExpiredAcc = () => {

    return (
        <>
            <div className="expacc">
                <h1 className="expacc-title text-jost-sb-50-wt">Welcome to your account</h1>

                <div className="expacc__wrap">

                    <div className="expacc__box">

                        <h2 className="expacc__box-txt text-jost-sb-24">Your Clubs Membership:</h2>



                        <div className="expacc__box-status">
                            <h2 className="expacc__box-txt text-jost-sb-24">Account Status:</h2>
                            <span className="text-ops-rg-18">Expired</span>
                        </div>
                        <p className="expacc__box-para text-ops-rg-18">It looks like your accounts membership has
                            expired, please click below to renew your membership</p>
                        <div className="expacc__box-links">

                            <NavLink to="/expired-renew-payment"  className="res-btn-primary">Renew membership</NavLink>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};
export default ExpiredAcc;